import type { CV2Result } from '@/models/aiScan';

// Which statements a CVv2 disease grades: its worksheet finding class, and a
// word the statement text must contain (the aortic valve carries both AS and
// AR, so the class alone can't tell them apart). Mirrors ingestion's
// CV2_DISEASE_TO_ATTRIBUTE.
const CV2_STATEMENTS: Record<string, { findingClass: string; word: string }> = {
  mitral_regurgitation: { findingClass: 'MITRAL_VALVE', word: 'regurgitation' },
  tricuspid_regurgitation: {
    findingClass: 'TRICUSPID_VALVE',
    word: 'regurgitation',
  },
  aortic_stenosis: { findingClass: 'AORTIC_VALVE', word: 'stenosis' },
  aortic_regurgitation: {
    findingClass: 'AORTIC_VALVE',
    word: 'regurgitation',
  },
};

/**
 * The clips the CVv2 severity behind a statement was made on, in the order
 * the backend sends them, without repeats. A combined "normal" statement
 * that names several conditions gets all of their clips. Empty when nothing
 * matches.
 */
export function cv2ClipsForStatement(
  results: readonly CV2Result[] | undefined,
  findingClass: string,
  text: string
): string[] {
  const lower = text.toLowerCase();
  const uuids = (results ?? [])
    .filter((result) => {
      const match = CV2_STATEMENTS[result.disease];
      return (
        !!match &&
        match.findingClass === findingClass &&
        lower.includes(match.word)
      );
    })
    .flatMap((result) =>
      result.dicoms
        .filter((dicom) => dicom.role === 'SEVERITY')
        .map((dicom) => dicom.dicomUuid)
    );
  return [...new Set(uuids)];
}
